<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div v-if="menuAnterior === false" class="col-12">
        <soft-alert v-show="importedGmail === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
          <strong>Imported correctly</strong> Data is being inserted, it may take up to 15 minutes to load every email. Every personal data will be deleted.
        </soft-alert>
        <emailsDatabase @go-back="goToMenu()" v-if="emails" />
        <documents @go-back="goToMenu()" v-if="docs"/>
        <webs @go-back="goToMenu()" v-if="webs"/>
        <questions @go-back="goToMenu()" v-if="questions"/>
      </div>
      <div v-else class="col-12">
        <div class="row">
          <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4">
            <div class="card" @click="goTo('docs')" style="cursor: pointer;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <!--<p class="mb-1 pt-2 text-bold">Import your files</p>-->
                      <h5 class="font-weight-bolder">Train AI with documents</h5>
                      <p class="mb-5">
                        Generate accurate responses to your client's questions based on your files, such as PDFs, Excels or Words.
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        href="javascript:;"
                      >
                        Import files
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-5 ms-auto text-center mt-5 mt-lg-0">
                    <div class="bg-gradient-primary border-radius-lg h-100">
                      <img
                        src="../assets/img/shapes/waves-white.svg"
                        class="position-absolute h-100 w-50 top-0 d-lg-block d-none"
                        alt="waves"
                      />
                      <div
                        class="position-relative d-flex align-items-center justify-content-center h-100"
                      >
                        <img style="padding: 10px;"
                          class="w-100 position-relative z-index-2 pt-4"
                          src="../assets/img/Add-files-pana.png"
                          alt="rocket"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4">
            <div class="card" @click="goTo('emails')" style="cursor: pointer;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <!--<p class="mb-1 pt-2 text-bold">Import your emails</p>-->
                      <h5 class="font-weight-bolder">Train AI with emails</h5>
                      <p class="mb-5">
                        Connect your email account and use your conversations 
                        to build powerful and targeted answers.
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        href="javascript:;"
                      >
                        Import emails
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-5 ms-auto text-center mt-5 mt-lg-0">
                    <div class="bg-gradient-primary border-radius-lg h-100">
                      <img
                        src="../assets/img/shapes/waves-white.svg"
                        class="position-absolute h-100 w-50 top-0 d-lg-block d-none"
                        alt="waves"
                      />
                      <div
                        class="position-relative d-flex align-items-center justify-content-center h-100"
                      >
                        <img style="padding: 10px;"
                          class="w-100 position-relative z-index-2 pt-4"
                          src="../assets/img/New-message-pana-grey.png"
                          alt="emails"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4">
            <div class="card" @click="goTo('webs')" style="cursor: pointer;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <h5 class="font-weight-bolder">Train AI with webs</h5>
                      <p class="mb-5">
                        Connect any web using its URL or Sitemap to train your AI model with its information.
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        href="javascript:;"
                      >
                        Import webs
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-5 ms-auto text-center mt-5 mt-lg-0">
                    <div class="bg-gradient-primary border-radius-lg h-100">
                      <img
                        src="../assets/img/shapes/waves-white.svg"
                        class="position-absolute h-100 w-50 top-0 d-lg-block d-none"
                        alt="waves"
                      />
                      <div
                        class="position-relative d-flex align-items-center justify-content-center h-100"
                      >
                        <img
                          style="padding: 10px;"
                          class="w-100 position-relative z-index-2 pt-4"
                          src="../assets/img/Static-website-pana.png"
                          alt="emails"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 mb-4">
            <div class="card" @click="goTo('questions')" style="cursor: pointer;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <h5 class="font-weight-bolder">Train AI with FAQ</h5>
                      <p class="mb-5">
                        Import your Frequently Asked Questions to let ToMate AI learn from them.
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        href="javascript:;"
                      >
                        Import FAQ
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-5 ms-auto text-center mt-5 mt-lg-0">
                    <div class="bg-gradient-primary border-radius-lg h-100">
                      <img
                        src="../assets/img/shapes/waves-white.svg"
                        class="position-absolute h-100 w-50 top-0 d-lg-block d-none"
                        alt="waves"
                      />
                      <div
                        class="position-relative d-flex align-items-center justify-content-center h-100"
                      >
                        <img
                          style="padding: 10px;"
                          class="w-100 position-relative z-index-2 pt-4"
                          src="../assets/img/FAQs-pana.png"
                          alt="questions"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- Modal video-->
    <a style="display: none;" id="botonAbrirTutorial" data-bs-toggle="modal" data-bs-target="#modalTutorial"
      class="btn text-secondary font-weight-bold text-xs"
      data-toggle="tooltip"
      data-original-title="Delete user">
      
    </a>
    <!--<div class="modal fade" data-bs-backdrop="static" id="modalTutorial" tabindex="-1" aria-labelledby="modalTutorialLabel" aria-hidden="true">
      <div style="width: fit-content;" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTutorialLabel">Two minutes training - Getting started with ToMate AI</h5>
            
          </div>
          <div class="modal-body">
            <iframe id="video_tutorial" width="560" height="315" style="border-radius: 15px;" 
            src="https://www.youtube.com/embed/mI3zR_kY3a8?enablejsapi=1&version=3&playerapiid=ytplayer" 
            title="YouTube video player" frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div class="modal-footer">
            <SoftButton @click="stopVideo()" data-bs-dismiss="modal">Got it</SoftButton>
          </div>
        </div>
      </div>
    </div>-->

    <div class="modal fade" data-bs-backdrop="static" id="modalTutorial" tabindex="-1" aria-labelledby="modalTutorialLabel" aria-hidden="true">
      <div style="width: fit-content;" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTutorialLabel">
              <img :src="logo" class="navbar-brand-img h-100" alt="main_logo" 
              style=" width: auto; max-height: 90px; margin: -30px 0;"/> 
              Getting started guide</h5>
            
          </div>
          <div class="modal-body" style="display: grid; justify-items: center;">
            <!--Primera slide-->
            <div v-show="pag1" style="display: grid; justify-items: center;">
              <h5>Welcome!</h5>
              <img @click="goToPag2()"
                style="padding: 10px;"
                class="w-50 position-relative z-index-2 pt-4"
                src="../assets/img/Launching-pana.png"
                alt="questions"
              />
              <p style="width: 80%; text-align: center;">Hi AI lover❤️🤖, we are here to make your customer support much easier. Start boosting your responses. 🚀</p>
              <SoftButton @click="goToPag2()" class="mt-3 mb-2">
                Let's go
              </SoftButton>
            </div>
            <!--Segunda slide-->
            <div v-show="pag2" style="display: grid; justify-items: center;">
              <h5>Add your company's website</h5>
              <img
                style="padding: 10px;"
                class="w-50 position-relative z-index-2 pt-4"
                src="../assets/img/www-pana.png"
                alt="questions"
              />
              <p style="width: 80%; text-align: center;">Paste your company's website down below, it'll help make our interactions smoother and smarter! 😊</p>
              <input
                style="width: 75%;"
                id="website-url"
                class="form-control"
                v-model="url"
                placeholder="Paste the website url here"
              />
              <span v-show="errorUrl" style="font-size: 12px;
              color: #fd5c70;">{{ messageErrorUrl }}</span>

              <SoftButton @click="mandarUrl()" class="mt-3 mb-2">
                Add to Database
              </SoftButton>
            </div>
            <!--Tercera slide-->
            <div v-show="pag3" style="display: grid; justify-items: center;">
              <h5>Which is your most frequent asked question?</h5>
              <img
                style="padding: 10px; margin: -75px 0;"
                class="w-50 position-relative z-index-2 pt-4"
                src="../assets/img/FAQs-pana-pink.png"
                alt="questions"
              />
              <p style="width: 80%; text-align: center;">Write down your most frequent asked question with its answer 🤷, 
                by doing this you are levering ToMate's potential. 🏎️</p>
              <label style="width: 75%;"><span>Question</span></label>
              <textarea
                style="width: 75%;"
                v-model="question"
                id="received"
                class="form-control"
                rows="2"
                placeholder="Write your question here"
              ></textarea>
              <span v-show="messageErrorQuestion.length !== 0" style="font-size: 12px;
              color: #fd5c70;">{{ messageErrorQuestion }}</span>

              <label style="width: 75%;"><span>Answer</span></label>
              <textarea
                style="width: 75%;"
                v-model="answer"
                id="response"
                class="form-control"
                rows="2"
                placeholder="Write your answer here"
              ></textarea>
              <span v-show="messageErrorAnswer.length !== 0" style="font-size: 12px;
              color: #fd5c70;">{{ messageErrorAnswer }}</span>

              <SoftButton @click="enviarFaq()" class="mt-3 mb-2">
                Add to Database
              </SoftButton>
            </div>
            <!--Cuarta slide-->
            <div v-show="pag4" style="display: grid; justify-items: center;">
              <h5>You are ready to start</h5>
              <img
                style="padding: 10px; margin: -15px 0;"
                class="w-50 position-relative z-index-2 pt-4"
                src="../assets/img/Ok-pana.png"
                alt="questions"
              />
              <p style="width: 80%; text-align: center;">Start crafting messages tailored to your clients requirements. ✅</p>
              <SoftButton data-bs-dismiss="modal" @click="goToConnections()" class="mt-3 mb-2">
                Go to Connections
              </SoftButton>
            </div>
          </div>
          <div style="padding: 15px; display: grid; justify-items: center;">
            <div style="width: 90%; display: contents; padding-top: 15px;">
              <div class="bar" :style="'border-radius: 5px; background-color: #f5f5f5; width: 90%; height: 15px; --percent: ' + porcentaje + ';'"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap; width: 90%;">
              <div style="flex: 1; width: 25%;">
                <b style="color: #cb0c9f" v-if="pag1">Welcome</b><span style="opacity: 0.6;" v-else>Welcome</span>
              </div>
              <div style="flex: 1; width: 25%;">
                <b style="color: #cb0c9f" v-if="pag2">Add your website</b><span style="opacity: 0.6;" v-else>Add your website</span>
              </div>
              <div style="flex: 1; width: 25%; text-align: right;">
                <b style="color: #cb0c9f" v-if="pag3">Add FAQ</b><span style="opacity: 0.6;" v-else>Add FAQ</span>
              </div>
              <div style="flex: 1; width: 25%; text-align: right;">
                <b style="color: #cb0c9f" v-if="pag4">Ready to start</b><span style="opacity: 0.6;" v-else>Ready to start</span>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: space-between;">
            <div>
              <a class="btn text-primary font-weight-bold text-xs no-margin" v-show="pag2" @click="goToPag1()">Back</a>
              <a class="btn text-primary font-weight-bold text-xs no-margin" v-show="pag3" @click="goToPag2()">Back</a>
              <a class="btn text-primary font-weight-bold text-xs no-margin" v-show="pag4" @click="goToPag3()">Back</a>
            </div>
             <SoftButton color="secondary" @click="cerrarWizard()" data-bs-dismiss="modal">Skip all</SoftButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailsDatabase from "./components/_emailsDatabase";
import documents from "./components/_documents";
import webs from "./components/_webs";
import questions from "./components/_questionsAndAnswers";
import SoftButton from "../components/SoftButton.vue"
import HTFetch from "../llamadas/HTFetch"
import SoftAlert from "@/components/SoftAlert.vue";
//import SoftPagination from "@/components/SoftPagination.vue";
//import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import logo from "@/assets/img/ToMate-black.png";
import router from '../router/index'

export default {
  name: "database",

  components: {
    emailsDatabase,
    webs,
    documents,
    questions,
    SoftAlert,
    SoftButton,
    //SoftPagination,
    //SoftPaginationItem
  },

  data() {
    return {
      llamada: new HTFetch(),
      importedGmail: false,
      responseMessage: "",
      showResponseMessage: false,
      emails: false,
      docs: false,
      webs: false,
      questions: false,
      menuAnterior: true,
      logo,
      pag1: true,
      pag2: false,
      pag3: false,
      pag4: false,
      tokenWizard: "",
      url: "",
      question: "",
      answer: "",
      porcentaje: 0,
      errorUrl: false,
      messageErrorUrl: "",
      messageErrorAnswer: "",
      messageErrorQuestion: ""
    }
  },

  created() {
    /*let arrDominios = ['"https://sibila.app', 'http://localhost:8081/congrat.html']

    window.addEventListener('message', function(event) {
      // Puedes comprobar el origen del mensaje por seguridad
      if (arrDominios.includes(event.origin)) {

        let url = new URL(event.origin);

        let url_params = new URLSearchParams(url.search); 

        let whitelabel = url_params.get('whitelabel')

        // Procesar el mensaje recibido
        console.log('Mensaje recibido:', event.data);

        //localStorage.ut = event.data.tk_tomate

        //sibila
        //if (whitelabel === 'sibila') {
          // Use dynamic import to conditionally load the CSS file
          import('../assets/css/whitelabels/whitelabel.css')
          import('../assets/css/whitelabels/css-sibila.css')
            .then(() => {
              console.log('CSS file imported successfully');
            })
            .catch((error) => {
              console.error('Error importing CSS file:', error);
            });
        //}

      } else {
        console.log('Origen no permitido:', event.origin);
      }
      
    });*/
    
  },

  mounted() {
    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "database",
        user_id: localStorage.userId
      });
    }
    //import "./assets/css/whitelabels/whitelabel.css";
    //import "./assets/css/whitelabels/css-sibila.css";

    //mostrar video si asi lo desea
    /*if (localStorage.getItem('tutorial_watched') === null) {
      localStorage.tutorial_watched = "false"
    }*/
    if (localStorage.getItem('tutorial_watched') === "false") {

      this.llamada.userInfo(this.userInfoRsp.bind(this))
      
      //muestro el video
      var myModalEl = document.getElementById('botonAbrirTutorial');
      myModalEl.click();
      localStorage.tutorial_watched = "true"
      
    }

    //checkeo si viene de google
    let link = location.href
    var regex = /access_token=([^&]+)/;
    var match = link.match(regex);

    if (match && match[1]) {
      var accessToken = match[1];

      let body = {
        'token': accessToken,
        'collection': localStorage.collectionImportGmail
      }

      this.llamada.gmailImport(body, this.gmailImportRsp.bind(this))

      var cleanURL = link.split("#")[0];

      // Reemplaza la URL actual sin redireccionar
      window.history.replaceState({}, document.title, cleanURL);

    } else {
      console.log("No se encontró ningún access token en la URL.");
    }

  },

  methods: {

    userInfoRsp(rsp) {
      if (rsp.status === 401) {
        
        this.llamada.userInfo(this.userInfoRsp.bind(this))
        return
      }
      
      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.document_collections).length; i++) {
        collecciones.push({
          "label": Object.keys(rsp.data.document_collections)[i],
          "value": Object.values(rsp.data.document_collections)[i]
        })
      }

      localStorage.docCollections = JSON.stringify(collecciones)

      this.tokenWizard = collecciones[0].value

      localStorage.userId = rsp.data.token
    },

    gmailImportRsp(rsp) {
      
      if (rsp.status === 200) {
        this.importedGmail = true
        this.menuAnterior = false
        this.emails = true

        setTimeout(() => {
          this.importedGmail = false
          
        }, 10000)
      } else {
        console.log(rsp)
        
      }
    },

    goTo(where) {
      
      if (where === 'docs') {
        this.menuAnterior = false
        this.emails = false
        this.docs = true
        this.webs = false
        this.questions = false

        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "docs",
            user_id: localStorage.userId
          });
        }
      }
      if (where === 'webs') {
        this.menuAnterior = false
        this.emails = false
        this.docs = false
        this.webs = true
        this.questions = false

        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "webs",
            user_id: localStorage.userId
          });
        }
      }
      if (where === 'emails') {
        this.menuAnterior = false
        this.emails = true
        this.docs = false
        this.webs = false
        this.questions = false

        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "emails",
            user_id: localStorage.userId
          });
        }
      }
      if (where === 'questions') {
        this.menuAnterior = false
        this.emails = false
        this.docs = false
        this.webs = false
        this.questions = true

        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "questions",
            user_id: localStorage.userId
          });
        }
      }
    },

    goToMenu() {
      this.menuAnterior = true
    },

    /*stopVideo() {
      let video = document.getElementById('video_tutorial')
      video.contentWindow.postMessage( '{"event":"command", "func":"stopVideo", "args":""}', '*');

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "stop-tutorial",
          user_id: localStorage.userId
        });
      }
    },*/

    cerrarWizard() {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "cerrar-wizard",
          user_id: localStorage.userId
        });
      }
    },

    goToPag1() {
      this.porcentaje = 0;
      this.pag1 = true;
      this.pag2 = false;
      this.pag3 = false;
      this.pag4 = false

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "pag1-wizard",
          user_id: localStorage.userId
        });
      };

    },

    goToPag2() {
      this.porcentaje = 33;
      this.pag1 = false;
      this.pag2 = true;
      this.pag3 = false;
      this.pag4 = false

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "pag2-wizard",
          user_id: localStorage.userId
        });
      };
      
    },

    goToPag3() {
      this.porcentaje = 70;
      this.pag1 = false;
      this.pag2 = false;
      this.pag3 = true;
      this.pag4 = false

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "pag3-wizard",
          user_id: localStorage.userId
        });
      };
      
    },

    goToPag4() {
      this.porcentaje = 100;
      this.pag1 = false;
      this.pag2 = false;
      this.pag3 = false;
      this.pag4 = true

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "pag4-wizard",
          user_id: localStorage.userId
        });
      };
      
    },

    mandarUrl() {
      this.errorUrl = false
      this.messageErrorUrl = ""

      if (!this.url.includes('https://') && !this.url.includes('http://')) {
        this.url = "https://" + this.url
      }

      let body = {
        "url": this.url,
        "type": 'url',
        "collection": [this.tokenWizard]
      }

      this.llamada.postWeb(body, this.postWebRsp.bind(this))

      //mando evento
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "send-web",
          user_id: localStorage.userId
        });
      }
    },

    postWebRsp(rsp) {

      if (rsp.status === 200) {
        console.log(rsp)
        this.goToPag3()
        
      } else {
        this.errorUrl = true
        this.messageErrorUrl = rsp.data.url[0]
        console.log(rsp)
      }

    },

    enviarFaq() {
      this.messageErrorAnswer = ""
      this.messageErrorQuestion = ""

      let body = {
        "question": this.question,
        "answer": this.answer,
        "collection": [this.tokenWizard]
      }

      this.llamada.postQuestion(body, this.postQuestionRsp.bind(this))

      //mando evento
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "send-question",
          user_id: localStorage.userId
        });
      }
    },

    postQuestionRsp(rsp) {

      if (rsp.status === 200) {
        console.log(rsp)
        this.goToPag4()
        
      } else {
        this.messageErrorAnswer = rsp.data.answer[0]
        this.messageErrorQuestion = rsp.data.question[0]
        console.log(rsp)
      }

    },

    goToConnections() {
      router.push({name: "Connections"})
    }
  }
};
</script>

<style>

  .bar::before {
    content: '';
    display: flex;
    justify-content: flex-end;
    width: calc(var(--percent) * 1%);
    height: 100%;
    border-radius: 5px;
    background: rgb(203, 12, 159);
    white-space: nowrap;
  }
</style>

